import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import Login from "views/LoginPage/LoginPage.jsx";

const indexRoutes = [
    
    { path: "/login", component: Login },
    { path: "/", component: Dashboard }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx